import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  private fundrichProduct = [ 'tlt', 'ipg', 'whn', 'ipi', 'ipj', 'wlc'];

  private firstlifeProduct = [ 'iph', 'wlc', 'iha', 'taa', 'isj', 'isk' ];

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const product = state.url.split('/')
      .find(u => [ ...this.fundrichProduct, ...this.firstlifeProduct ].includes(u)) || '';
    if ( route.routeConfig.path === 'fundrich' && !this.fundrichProduct.includes(product) ) {
      window.location.href = environment.FUNDRICH_INDEX_URL;
      return false;
    } else if ( route.routeConfig.path === '' && !this.firstlifeProduct.includes(product) ) {
      window.location.href = environment.FIRST_LIFE_INSURANCE_INDEX_URL;
      return false;
    }
    return true;
  }
}
